export const blockIconsHomeSensorWindow = (
	<span className='material-symbols-outlined'>sensor_window</span>
);
